export default __webpack_public_path__ + "media/images/react_icons/message-ac68ec2cd0d53e8d4da815e80c8f1a55.svg";